import { render, staticRenderFns } from "./ModelBinding.vue?vue&type=template&id=725f96da&scoped=true&"
import script from "./ModelBinding.vue?vue&type=script&lang=js&"
export * from "./ModelBinding.vue?vue&type=script&lang=js&"
import style0 from "./ModelBinding.vue?vue&type=style&index=0&id=725f96da&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725f96da",
  null
  
)

export default component.exports